'use client'
import {apiBaseUrl} from '@fitro/customer-host/api'
import {DescriptionContent, DescriptionIntro, FullDescriptionSection, InlineDescription} from '@fitro/customer-ui/DescriptionContent'
import {useTranslation} from '../../../hooks/useTranslation'

type DescriptionProps = {description?: string | null; fullDescriptionHtml?: string | null}
function useLabels() {
    const {t} = useTranslation('common')
    const {t: landing} = useTranslation('landing')
    return {expand: t('expandDescription'), collapse: t('collapseDescription'), full: landing('publicEntry.details.fullDescription')}
}
export function ActivityDescriptionIntro(props: DescriptionProps) {
    const {t} = useTranslation('landing')
    return <DescriptionIntro {...props} assetBaseUrl={apiBaseUrl} labels={useLabels()} title={t('publicEntry.details.about')}/>
}
export function ActivityFullDescription(props: DescriptionProps) {
    return <FullDescriptionSection {...props} assetBaseUrl={apiBaseUrl} labels={useLabels()}/>
}

export function ActivityDescription(props: DescriptionProps) {
    return <DescriptionContent {...props} assetBaseUrl={apiBaseUrl} labels={useLabels()}/>
}

export function ActivityInlineDescription(props: DescriptionProps) {
    const {t} = useTranslation('landing')
    return <InlineDescription {...props} assetBaseUrl={apiBaseUrl} labels={useLabels()} title={t('publicEntry.details.about')}/>
}
